<div class="home-breadcrumb-wrapper">
  <p-breadcrumb [home]="home" [model]="emptyBreadcrumb" styleClass="home-breadcrumb"></p-breadcrumb>
  <button
    pButton
    type="button"
    icon="pi pi-cog"
    class="p-button-text p-button-sm home-settings-button"
    (click)="toggleSettings()"
    pTooltip="Customize cards"
    tooltipPosition="left"
  ></button>

  <div *ngIf="settingsOpen" class="home-settings-panel" (click)="$event.stopPropagation()">
    <div class="home-settings-item" *ngFor="let card of settingsCards">
      <label class="home-settings-toggle">
        <input
          type="checkbox"
          [checked]="isCardVisible(card.id)"
          (change)="toggleCard(card.id)"
        >
        <i class="pi {{ card.icon }}"></i>
        <span>{{ card.label }}</span>
      </label>
      <div class="home-settings-reorder" *ngIf="isCardVisible(card.id)">
        <button
          pButton
          type="button"
          icon="pi pi-chevron-up"
          class="p-button-text p-button-sm home-reorder-btn"
          [disabled]="cardPosition(card.id) === 0"
          (click)="moveCard(card.id, -1)"
        ></button>
        <button
          pButton
          type="button"
          icon="pi pi-chevron-down"
          class="p-button-text p-button-sm home-reorder-btn"
          [disabled]="cardPosition(card.id) === activeCards.length - 1"
          (click)="moveCard(card.id, 1)"
        ></button>
      </div>
    </div>
  </div>
</div>

<div class="home-settings-overlay" *ngIf="settingsOpen" (click)="closeSettings()"></div>

<div class="home-page jobsv2-{{ colorScheme.colorScheme.value }}">
  <div class="home-grid">
    <div
      *ngFor="let card of activeCards; let i = index"
      class="home-card-wrapper"
      [class.dragging]="draggingIndex === i"
      [attr.draggable]="isDesktop ? true : null"
      (dragstart)="onDragStart(i)"
      (dragover)="onDragOver($event, i)"
      (dragend)="onDragEnd()"
    >
      <div class="home-card">
        <div class="home-card-header">
          <span class="home-card-title">
            <i class="pi {{ card.config.icon }}"></i>
            {{ card.config.label }}
          </span>
          <i class="pi pi-bars home-card-drag-handle" title="Drag to reorder"></i>
        </div>
        <div class="home-card-body">
          <ng-container *ngComponentOutlet="card.component"></ng-container>
        </div>
      </div>
    </div>
  </div>
</div>